const drawerOpen = (state) => state.drawerOpen
const alert = (state) => state.alert
const loader = (state) => state.loader
const currentModule = (state) => state.currentModule
const axiosHideLoader = (state) => state.axiosHideLoader
const tenant = (state) => state.tenant
const tenantOrganisation = (state) => state.tenantOrganisation
const newVersionSnackbar = (state) => state.newVersionSnackbar
const routeCount = (state) => state.routeCount
const versionCheck = (state) => state.versionCheck
const changeLogNewVersion = (state) => state.changeLogNewVersion

export default {
  drawerOpen,
  alert,
  loader,
  currentModule,
  axiosHideLoader,
  tenant,
  tenantOrganisation,
  newVersionSnackbar,
  routeCount,
  versionCheck,
  changeLogNewVersion
}
